import { RefObject, useLayoutEffect, useState } from "react";


export function useSyncedSecondRowHeight(
  additionalInfoCardRef: RefObject<HTMLElement | null>
): number {
  const [additionalInfoCardHeightPx, setAdditionalInfoCardHeightPx] = useState(0);

  useLayoutEffect(() => {
    const additionalInfoCardElement = additionalInfoCardRef.current;
    if (!additionalInfoCardElement) return;

    const measureHeightAndUpdateState = () => {
      // offsetHeight = espaço de layout (mesmo do CSS height). getBoundingClientRect
      // devolve altura visual e, com zoom no #root, a lista de categorias ficava menor.
      const measuredHeightPixels = additionalInfoCardElement.offsetHeight;
      if (measuredHeightPixels > 0) {
        setAdditionalInfoCardHeightPx(Math.round(measuredHeightPixels));
      }
    };

    measureHeightAndUpdateState();
    const resizeObserver = new ResizeObserver(() => measureHeightAndUpdateState());
    resizeObserver.observe(additionalInfoCardElement);
    return () => resizeObserver.disconnect();
  }, [additionalInfoCardRef]);

  return additionalInfoCardHeightPx;
}
